module.exports = __webpack_public_path__ + "img/baidu.59230de0.svg";